module.exports = __webpack_public_path__ + "static/media/ops_bookmark_en.ef8fd3ee.jpeg";